<template>
  <div class="indexs">
    <!-- <h3 class="buy-title">
      实际支付金额
      <span
        >订单提交成功，请尽快付款！订单号：{{
          this.$route.query.orderNum
        }}</span
      >
    </h3>
    <p class="price">￥{{ this.$route.query.total }}</p> -->
    <div class="title">订单详情：</div>
    <div class="infos">
      <div>收款方：彦旭科技（武汉）有限公司</div>
      <div>订单号：{{this.$route.query.orderNum}}</div>
      <div v-if="this.$route.query.name">
        <div class="flex">
          <div>
            商品名称：{{this.$route.query.name}}
          </div>
          <div class="infosize">（{{this.$route.query.person}}人）</div>
          <div v-if="this.$route.query.buynum">{{this.$route.query.num*this.$route.query.buynum}}条</div>
          <div v-else>
            {{this.$route.query.num}}条
          </div>
        </div>
      </div>
      <div v-if="this.$route.query.smsnum">
        <div class="flex">
          <div>
            商品名称：{{this.$route.query.smsnum}}条x{{this.$route.query.number}}
          </div>
        </div>
      </div>
      <div >支付金额：<span>￥{{this.$route.query.total}}</span></div>
    </div>
    <div class="info-container" :style="{'background':this.$route.query.smsnum?'rgba(250,100,0,0.1)':'rgba(59, 196, 146, 0.15)','border':this.$route.query.smsnum?'1px dashed #FA6400':'1px dashed #3bc492'}">
      <!-- <div class="info-img"></div> -->
      <div class="info-cotent">
        <h4>通过银行转账进行支付，并将支付成功的页面截图当做凭证进行上传</h4>
        <div class="info-cotent-detail">
          <div class="info-cotent-detail-dt">
            <p>户名</p>
            <p>支行</p>
            <p>卡号</p>
            <p>上传凭证</p>
          </div>
          <div class="info-cotent-detail-dd">
            <p>彦旭科技（武汉）有限公司</p>
            <p>招商银行光谷科技支行</p>
            <p>1279 1145 7610 801</p>
            <p style="height: 120px">
              <el-upload ref="upload1" :limit="1" :headers="{
                  Authorization: uploadToken,
                }" :action="`${$http.defaults.baseURL}/salary-service/customer/uploadFile`" list-type="picture-card" :on-preview="handlePictureCardPreview" :before-upload="handleBefore1" :on-success="handleSuccess1" :on-remove="handleRemove1" accept="image/gif,image/jpeg,image/jpg,image/png">
                <i class="el-icon-plus"></i>
              </el-upload>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div style="width:60%">
      <el-button :style="{'display': 'inherit','background':this.$route.query.smsnum?'#FA6400 !important':'#3bc492 !important'}" class="next-btn" type="success" @click="hanldeSubmit">提交审核</el-button>
    </div>
    <el-dialog :visible.sync="ImgdialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>

  </div>
</template>

<script>
import Cookie from 'js-cookie'
export default {
  name: 'index',
  props: {
    title: String,
    frompath: String
  },
  components: {},
  data () {
    return {
      uploadToken: 'Bearer ' + window.sessionStorage.getItem('token'),
      fileList1: [],
      lincenseImg: '',
      dialogImageUrl: '',
      ImgdialogVisible: false,
      userInfo: {},
      frompath: '',
      timer: null,
    }
  },


  methods: {
    hanldeSubmit () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if (this.lincenseImg) {
          if (this.$route.query.type != 'recharge') {
            this.$http
              .post('salary-service/customer/order/confirm_payment', {
                orderId: this.$route.query.orderNum,
                payment: 2,
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$http
                    .post('salary-service/customer/order/update', {
                      id: this.$route.query.orderNum,
                      invoice: false,
                      payment: 2,
                      voucherUrl: this.lincenseImg,
                    })
                    .then((res) => {
                      this.$store.commit('setPayDone', true)
                      this.$router.replace(this.frompath)
                      this.$store.commit('setPayDone', false)
                      this.$notify({
                        title: '成功',
                        message: '套餐订单提交成功，工作人员会尽快审核',
                        type: 'success',
                      })

                      this.$store.commit('orderStepBack')
                    })
                } else {
                  this.$notify({
                    title: '失败',
                    message: res.data.msg,
                    type: 'error',
                  })
                }

              })
          } else {
            this.$http
              .post('salary-service/customer/rechargeOrder/confirm_payment', {
                orderId: this.$route.query.orderNum,
                payment: 2,
              })
              .then((res) => {
                this.$http
                  .post('salary-service/customer/recharge_order/update', {
                    id: this.$route.query.orderNum,
                    invoice: false,
                    payment: 2,
                    voucherUrl: this.lincenseImg,
                  })
                  .then((res) => {
                    this.$store.commit('setPayDone', true)
                    this.$router.replace('/index/new')
                    this.$store.commit('setPayDone', false)
                    this.$notify({
                      title: '成功',
                      message: '充值订单提交成功，工作人员会尽快审核',
                      type: 'success',
                    })
                  })
              })
          }
        } else {
          this.$notify({
            title: '失败',
            message: '请先上传转账凭证',
            type: 'warning',
          })
        }
      }, 1000)

    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.ImgdialogVisible = true
    },
    handleBefore1 () {
      this.$refs.upload1.$children[1].$el.style.display = 'none'
      this.$refs.upload1.$children[0].$el.style.display = 'inline-block'
    },
    handleSuccess1 (response, file, fileList) {
      if (response.code == 200) {
        this.fileList1 = fileList.length

        this.lincenseImg = response.data
      } else {
        this.$notify({
          title: '失败',
          message: `${response.message},请删除后重新上传`,
          type: 'warning',
        })
      }
    },
    handleRemove1 (file, fileList) {
      this.$refs.upload1.$children[0].$el.style.display = 'none'
      this.$refs.upload1.$children[1].$el.style.display = 'flex'
      this.lincenseImg = ''
    },
  },
  mounted () { },
}
</script>

<style lang="less" scoped>
// .avatar-uploader{
//     height: 100px;
//     width: 100px;
//     background-color: #fff;
//     line-height: 100px;
//     text-align: center;
//     border: 1px dashed #d9d9d9;
//     border-radius: 6px;
//      cursor: pointer;
// }
// .avatar{
//     width: 90px;
//     height: 90px;
// }

.indexs {
  width: 100%;
  background: #fff;
  padding: 15px 18px 0px 18px;
  border-radius: 8px;
  height:calc(100vh - 148px);
  overflow: auto;
  .title {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #2c2d3a;
    line-height: 28px;
  }
  .infos {
    margin-top: 16px;
    div {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.7);
      line-height: 30px;
      span {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2c2d3a;
        line-height: 32px;
        line-height: 40px;
      }
    }
  }
}
.buy-title {
  font-size: 18px;
  font-weight: 600;
  color: rgba(44, 45, 58, 1);
  span {
    font-size: 16px;
    font-weight: 400;
    color: rgba(44, 45, 58, 1);
    float: right;
    line-height: 27px;
  }
}
.price {
  padding: 16px 5px;
  font-size: 32px;
  font-weight: 600;
  color: rgba(44, 45, 58, 1);
}

.info-container {
  width: 60%;
  border-radius: 8px;
  padding: 15px;
  display: flex;
  margin-top:10px;
  .info-img {
    width: 36px;
  }
  .info-cotent {
    flex: 1;
    h4 {
      font-size: 16px;
      font-weight: 600;
      color: rgba(255, 97, 97, 1);
    }
    &-detail {
      display: flex;
      padding-top:15px;
      p {
        font-size: 16px;
        line-height: 30px;
      }
      &-dt {
        color: #838f99;
        width: 80px;
      }
      &-dd {
        flex: 1;
      }
    }
  }
}
.next-btn {
  margin-top: 10px !important;
  border-radius: 4px !important;
  width: 200px;
  height: 40px;
  border-radius: 20px !important;

  line-height: 40px;
  padding: 0 !important;
  border-color: #fff;
  font-size: 16px !important;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: left;
}
</style>
